import { render, staticRenderFns } from "./agendaCard.vue?vue&type=template&id=10743c32&"
import script from "./agendaCard.vue?vue&type=script&lang=js&"
export * from "./agendaCard.vue?vue&type=script&lang=js&"
import style0 from "./agendaCard.vue?vue&type=style&index=0&id=10743c32&prod&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports